exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading[data-v-17be5d76] {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.loading__holder[data-v-17be5d76] {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    align-items: center;\n    justify-content: center;\n}\n.loading__holder span[data-v-17be5d76], .loading__holder i[data-v-17be5d76] {\n      color: #999;\n}\n.loading__holder i[data-v-17be5d76] {\n      font-size: 30px;\n}\n.loading__holder span[data-v-17be5d76] {\n      font-size: 11px;\n}\n", ""]);

// exports
